webpackJsonp([277133744887648],{

/***/ 1643:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/samantha-smith/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-samantha-smith-70d11258fd7e9b48e8f8.js